export * from './list-2-res.model';
